import { Form7Field } from "./types";
import {
  createEarlyEnrollmentApprovedPayload,
  createEarlyEnrollmentRejectedPayload,
  createEnrollmentPostponementPayload,
  createTemporaryExemptionApprovedPayload,
  createTemporaryExemptionRejectedPayload,
  createAppropriateProgramPayload,
  createPreparatoryCoursePayload,
} from "./utils";
import { Form7, Request } from "../../../../../models/Request";

export const PAYLOAD_CREATORS: Record<
  Form7Field,
  (form7: Form7, item: Request, value: boolean) => Form7
> = {
  isEarlyEnrollmentApproved: createEarlyEnrollmentApprovedPayload,
  isEarlyEnrollmentRejected: createEarlyEnrollmentRejectedPayload,
  isEnrollmentPostponement: createEnrollmentPostponementPayload,
  isTemporaryExemptionApproved: createTemporaryExemptionApprovedPayload,
  isTemporaryExemptionRejected: createTemporaryExemptionRejectedPayload,
  isAppropriateProgram: createAppropriateProgramPayload,
  isPreparatoryCourse: createPreparatoryCoursePayload,
};
